import { render, staticRenderFns } from "./SidebarSummaryRow.vue?vue&type=template&id=7f36e1df&scoped=true&"
import script from "./SidebarSummaryRow.vue?vue&type=script&lang=js&"
export * from "./SidebarSummaryRow.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSummaryRow.vue?vue&type=style&index=0&id=7f36e1df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f36e1df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VChip,VCol,VRow,VTooltip})
